export function incrementItem(breadcrumbOld: any) {
  const splitsOld = breadcrumbOld.split(".");

  const last: any = splitsOld.pop();

  const inc = +last + 1;

  splitsOld.push(`${inc}`);

  const nextCode = splitsOld.join(".");

  return `${nextCode}`;
}
